/**
 * 所有接口api
 * method: get, post, delete, patch, put, head
 */
import axios from './index';
import {formatObjToUrl} from "../config/Utility";
import fetch from './fetch';

// 动态获取headers
const getHeaders = () => {
  return {
    'Authorization': window.localStorage.getItem('token'),
  }
};

/**
 * 实名认证
 *
 */
export const RealnameApi = data => {
  return fetch({
    url: `/user/realname`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

/**
 * 退款
 *
 */
export const RefundApi = data => {
  return fetch({
    url: `/voucher/refund`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

/**
 * 获取微信分享config信息
 */
export const configApi = (data) => {
  return fetch({
    url: '/wxsign',
    method: 'get',
    params: data,
    data:{mask:0},
    headers: getHeaders()
  });
};

// 注销账户
export const delAccountApi = (data) => {
  return fetch({
    url: '/delAccount',
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

/**
 * 购买支付
 *
 */
export const BuyPayApi = data => {
  return fetch({
    url: `/voucher/store`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

/**
 * 购物券主页
 *
 */
export const CouponIndexApi = (params) => {
  return fetch({
    url: `/voucher/index`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

/**
 * 奖励中心
 *
 */
export const cashIndexApi = (params) => {
    return fetch({
      url: `/index/cash`,
      method: 'get',
      params,
      headers: getHeaders()
    });
  };
/**
 * 奖励流水
 *
 */
export const cashRewardApi = (params) => {
  return fetch({
    url: `/cash/reward`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 奖励提现记录
 *
 */
export const withdrawApi = (params) => {
  return fetch({
    url: `/withdraw`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 奖励提现记录
 *
 */
export const withdrawTranApi = (params) => {
  return fetch({
    url: `/withdraw/tran`,
    method: 'post',
    params,
    headers: getHeaders()
  });
};

export const bondBuyApi = (params) => {
  return fetch({
    url: `/bond/buy`,
    method: 'post',
    data:params,
    headers: getHeaders()
  });
};

export const withdrawStoreApi = (params) => {
  return fetch({
    url: `/withdraw/store`,
    method: 'post',
    params,
    headers: getHeaders()
  });
};
/**
 * 个人中心页
 *
 */
export const UserIndexApi = (params) => {
  return fetch({
    url: `/user/index`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 使用记录
 *
 */
export const VoucherFlowApi = (params) => {
  return fetch({
    url: `/voucher/flow`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

/**
 * 首页
 *
 */
export const IndexApi = (params) => {
  return fetch({
    url: `/index`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

/**
 * 获取开发模式
 *
 */
export const ModeApi = (params) => {
  return fetch({
    url: `/mode`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

/**
 * 搜索
 *
 */
export const GoodsSearchApi = (params) => {
  return fetch({
    url: `/goods/search`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 99拼团主页
 *
 */
export const PinIndexApi = (params) => {
  return fetch({
    url: `/pin/index`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 兑换积分主页
 */
export const IntegralIndexApi = (params) => {
  return fetch({
    url: `/goods/integral`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 兑换积分中心
*/
export const IntegralCenterApi = (params) => {
  return fetch({
    url: `/index/integral`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

/**
 * 数字通证中心
*/
export const DigitalCenterApi = (params) => {
  return fetch({
    url: `/index/digitalToken`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};


/**
 * 兑换积分中心
 */
export const IntegralCenterApis = (params) => {
  return fetch({
    url: `/ticket/flow`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 云仓配额流水
 */
export const FlowQuota = (params) => {
  return fetch({
    url: `/quota/flow`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 分红流水
 */
export const FlowShares = (params) => {
  return fetch({
    url: `/shares/flow`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 兑换积分中心
 */
export const bondApi = (params) => {
  return fetch({
    url: `/bond/flow`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

/**
 * 批发商配额流水
 */
export const QuotaApi = (params) => {
  return fetch({
    url: `/quota/flow`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};


/**
 * 批发商提货
 *
 */
export const WithdrawQuotaApi = (data) => {
  return fetch({
    url: `/quota/withdraw`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

//配额转积分
export const quotaTransferScoreApi = (data) => {
  return fetch({
    url: `/quota/transferScore`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

/**
 * 提现
 *
 */
export const WithdrawApi = (data) => {
  return fetch({
    url: `/voucher/withdraw`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

/**
 * 转让数字通证
 *
 */
export const TransferDigitalApi = (data) => {
  return fetch({
    url: `/digitalToken/transfer`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

/**
 * 转让
 *
 */
export const TransferApi = (data) => {
  return fetch({
    url: `/integral/transfer`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

export const scoreTransferQuotaApi = (data) => {
  return fetch({
    url: `/integral/transferQuota`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

export const TransferApis = (data) => {
  return fetch({
    url: `/integral/turnTicket`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};
export const creditScoreTransferApis = (data) => {
  return fetch({
    url: `/creditScore/transfer`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};
/**
 * 修改支付密码
 *
 */
export const PayPasswordApi = (data) => {
  return fetch({
    url: `/user/updatePayPassword`,
    method: 'post',
    params: data,
    headers: getHeaders()
  });
};
export const SetPayPasswordApi = (data) => {
  return fetch({
    url: `/user/setPayPassword`,
    method: 'post',
    params: data,
    headers: getHeaders()
  });
};
/**
 * 商品详情
 *
 */
export const GoodsDetailApi = (id) => {
  return fetch({
    url: `/goods/${id}/find`,
    method: 'get',
    headers: getHeaders()
  });
};

//0 share ready
export const APPVersion =(params) => {
  return fetch({
    url: `/app/version?type=1`,
    method: 'get',
    headers: getHeaders()
  });
};
/**
 * 收货地址-修改
 */
export const addressUpdateApi = data => {
  return fetch({
    url: '/address/update',
    method: 'post',
    data,
    headers: getHeaders()
  });
};

/**
 * 协议
 * addressInfo
 */
export const protocolApi = id => {
  return fetch({
    url: `/document/${id}/find`,
    method: 'get',
    headers: getHeaders()
  });
};
/**
 * 收货地址-设置默认
 */
export const addressDefaultApi = data => {
  return fetch({
    url: '/address/default',
    method: 'patch',
    data,
    headers: getHeaders()
  });
};

/**
 * 收货地址-删除
 */
export const addressDestroy = data => {
  return fetch({
    url: '/address/destroy',
    method: 'post',
    data,
    headers: getHeaders()
  });
};

/**
 * 收货地址-列表
 * address
 */
export const addressApi = data => {
  return fetch({
    url: '/address',
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

/**
 * 收货地址-详情
 * addressInfo
 */
export const addressInfoApi = id => {
  return fetch({
    url: `/address/${id}`,
    method: 'get',
    headers: getHeaders()
  });
};


/**
 * 确认下单
 *
 */
export const GoodsConfirmApi = params => {
  return fetch({
    url: `/goods/confirm`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};



/**
 * 提交下单
 *
 */
export const OrderStoreApi = data => {
  return fetch({
    url: `/order/store`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};
/**
 * 收货地址-新增
 */
export const addressStoreApi = data => {
  return fetch({
    url: '/address/store',
    method: 'post',
    data,
    headers: getHeaders()
  });
};

export const addressConfirm = params => {
  return fetch({
    url: '/order/addressConfirm',
    method: 'post',
    params,
    headers: getHeaders()
  })
};


export const RealNameApi = data => {
  return fetch({
    url: '/user/realname',
    method: 'post',
    data,
    headers: getHeaders()
  })
};

//申请退券
export const ZeroRefundApi = data => {
  return fetch({
    url: '/bidding/turn',
    method: 'post',
    data,
    headers: getHeaders()
  })
};
//兑换积分红包发送
export const IntegralStoreApi = data => {
  return fetch({
    url: '/integralEnvelope/store',
    method: 'post',
    data,
    headers: getHeaders()
  })
};
//兑换积分红包领取
export const IntegralReceiveApi = data => {
  return fetch({
    url: '/integralEnvelope/receive',
    method: 'post',
    data,
    headers: getHeaders()
  })
};
/**
 * 兑换积分红包详情
 * addressInfo
 */
export const IntegralFindApi = id => {
  return fetch({
    url: `/integralEnvelope/${id}/find`,
    method: 'get',
    headers: getHeaders()
  });
};
/**
 * 兑换积分红包获取
 * addressInfo
 */
export const IntegralPageApi = (id) => {
  return fetch({
    url: `/integralEnvelope/${id}/page`,
    method: 'get',
    headers: getHeaders()
  });
};
/**
 * 修改收貨地址
 */
export const changeGoodAdd = data => {
  return fetch({
    url: '/order/updateAddress',
    method: 'patch',
    data,
    headers: getHeaders()
  })
};


/**
 * 确认下单
 *
 */
export const ZeroGoodList = params => {
  return fetch({
    url: `/bidding/order`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 文章列表
 *
 */
export const ArticleListApi = params => {
  return fetch({
    url: `/article/lists`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

/**
 * 激活奖励
 *
 */
export const activateApi = params => {
  return fetch({
    url: `/index/activate`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 拼团提示
 *
 */
export const pinTipsApi = params => {
  return fetch({
    url: `/index/pinTips`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 订单详情
 *
 */
export const OrderDetailApi = id => {
  return fetch({
    url: `/order/${id}/find`,
    method: 'get',
    headers: getHeaders()
  });
};

/**
 * 订单详情
 *
 */
export const OrderListApi = (params) => {
  return fetch({
    url: `/order/user`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};


/**
 * 兑换积分流水
 */
export const IntegralFlowApi = (params) => {
  return fetch({
    url: `/integral/flow`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

/**
 * 数字通证流水
 */
export const DigitalFlowApi = (params) => {
  return fetch({
    url: `/digitalToken/flow`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

/**
 * 兑换积分奖励
 */
export const IntegralRewardApi = (params) => {
  return fetch({
    url: `/integral/reward`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

/**
 * 兑换积分奖励
 */
export const userInfoApi = (params) => {
  return fetch({
    url: `/user/info`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 兑换积分奖励
 */
export const FansApi = (params) => {
  return fetch({
    url: `/user/fans`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 客服
 */
export const ServiceApi = (params) => {
  return fetch({
    url: `/index/service`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 祈福资讯详情
 * articleInfo
 */
export const articleInfoApi = (id, user_id = '') => {
  return fetch({
    url: `/article/${id}?user_id=${user_id}`,
    headers: getHeaders(),
  })
};

/**
 * 上传图片
 * uploadImgBase
 */
export const uploadImgBaseApi = data => {
  return fetch({
    url: `/public/uploadImgBase`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};
/**
 * 信息修改
 * myInfo
 */
export const userUpdateApi = data => {
  return fetch({
    url: '/user/update',
    method: 'post',
    data,
    headers: getHeaders()
  });
};
/**
 * 信息修改
 * myInfo
 */
export const userUpdatePayApi = data => {
  return fetch({
    url: '/user/paymentMethod',
    method: 'post',
    data,
    headers: getHeaders()
  });
};


/**
 * 绑定手机号
 * bindMobile
 */
export const updateMobileApi = data => {
  return fetch({
    url: '/user/updateMobile',
    method: 'patch',
    data,
    headers: getHeaders()
  });
};

/**
 * 绑定业务员
 */
export const userBindRefereeIdApi = user_id => {
  const data = {
    user_id,
    _method: 'patch'
  };
  return fetch({
    url: '/user/bindRefereeId',
    method: 'patch',
    data,
    headers: getHeaders()
  })
};


/**
 * 修改支付密码
 */
export const userUpdatePayPasswordApi = data => {
  return fetch({
    url: '/user/updatePayPassword',
    method: 'patch',
    data,
    headers: getHeaders()
  })
};

export const myGoodsOrderLogisticsApi = data => {
  return fetch({
    url: `/order/logistics`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};
export const myPrizeLogisticsApi = data => {
  return fetch({
    url: `/luckDraw/logistics`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};


export const qrcodeApi = data => {
  return fetch({
    url: `/user/qrcode`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

export const integralBidApi = data => {
  return fetch({
    url: `/integralBid/index`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};
export const integralBidOrderApi = data => {
  return fetch({
    url: `/integralBid/order`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

export const integralBidStoreApi = data => {
  return fetch({
    url: '/integralBid/store',
    method: 'post',
    data,
    headers: getHeaders()
  });
};

export const integralBidCancelApi = data => {
  return fetch({
    url: '/integralBid/cancel',
    method: 'post',
    data,
    headers: getHeaders()
  });
};

export const integralBidCancelBidApi = data => {
  return fetch({
    url: '/integralBid/cancelBid',
    method: 'post',
    data,
    headers: getHeaders()
  });
};

export const integralBidBuyApi = data => {
  return fetch({
    url: '/integralBid/buy',
    method: 'post',
    data,
    headers: getHeaders()
  });
};
/**
 * 商品分类
 */
export const goodsClassApi = (params) => {
  return fetch({
    url: `/goodsClass`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

export const integralBidSellApi = data => {
  return fetch({
    url: '/integralBid/sell',
    method: 'post',
    data,
    headers: getHeaders()
  });
};

export const integralBidFindApi = id => {
  return fetch({
    url: `/biddingOrder/${id}/find`,
    method: 'get',
    headers: getHeaders()
  });
};

export const integralBidFindApis = id => {
  return fetch({
    url: `/integralBid/${id}/find`,
    method: 'get',
    headers: getHeaders()
  });
};
export const integralBidConfirmApi = data => {
  return fetch({
    url: `/bidding/confirm`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};
export const integralBidConfirmApis = data => {
  return fetch({
    url: `/integralBid/confirm`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};


export const integralBidUserApi = data => {
  return fetch({
    url: `/integralBid/user`,
    method: 'get',
    params:data,
    headers: getHeaders()
  });
};

export const paymentMethod = data => {
  return fetch({
    url: `/user/paymentMethod`,
    method: 'get',
    params:data,
    headers: getHeaders()
  });
};

export const updateMin = data => {
  return fetch({
    url: `/integralBid/updateMin`,
    method: 'post',
    params:data,
    headers: getHeaders()
  });
};

export const withdrawIndexApi = data => {
  return fetch({
    url: `/withdraw/index`,
    method: 'get',
    params:data,
    headers: getHeaders()
  });
};
/**
 * 检查是否关注公众号
 */
export const valiFollow = () => {
  return fetch({
    url: '/user/isOfficialAccount',
    data:{mask:0},
    headers: getHeaders()
  })
};
export const reviveIndexApi = data => {
  return fetch({
    url: `/revive/index`,
    method: 'get',
    params:data,
    headers: getHeaders()
  });
};

export const reviveStoreApi = data => {
  return fetch({
    url: `/revive/store`,
    method: 'post',
    params:data,
    headers: getHeaders()
  });
};

export const ShareBgApi = data => {
  return fetch({
    url: `/shareBg`,
    method: 'get',
    params:data,
    headers: getHeaders()
  });
};
export const bindRefereeApi = data => {
  return fetch({
    url: `/user/bindReferee`,
    method: 'post',
    params:data,
    headers: getHeaders()
  });
};

//代付信息
export const otherPay = params => {
  return fetch({
    url: '/order/otherFind',
    method: 'get',
    data:{mask:0},
    params,
    headers: getHeaders()
  })
};

//代付付款
export const otherPayNow = params => {
  return fetch({
    url: '/order/otherPay',
    method: 'post',
    params,
    headers: getHeaders()
  })
};
//代付付款
export const integralZoneStore = params => {
  return fetch({
    url: '/bidding/buy',
    method: 'post',
    params,
    headers: getHeaders()
  })
};

//代付付款
export const integralZoneExchange = params => {
  return fetch({
    url: '/integralZone/exchange',
    method: 'post',
    params,
    headers: getHeaders()
  })
};

//代付付款
export const integralZoneTrust = params => {
  return fetch({
    url: '/bidding/subscribe',
    method: 'post',
    params,
    headers: getHeaders()
  })
};

export const integralZone = data => {
  return fetch({
    url: `/bidding/new`,
    method: 'get',
    params:data,
    headers: getHeaders()
  });
};


export const integralZoneZero = data => {
  return fetch({
    url: `/integralZone/zero`,
    method: 'get',
    params:data,
    headers: getHeaders()
  });
};

export const integralZoneList = data => {
  return fetch({
    url: `/integralZone/exchangeList`,
    method: 'get',
    params:data,
    headers: getHeaders()
  });
};
/**
 * 活动
 *
 */
export const activityApi = (params) => {
  return fetch({
    url: `/activity`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
export const subLottery = params => {
  return fetch({
    url: '/pbcDraw/store',
    method: 'post',
    params,
    headers: getHeaders()
  })
};
export const DrawIndex = (params) => {
  return fetch({
    url: '/luckDraw/index',
    method: 'get',
    params,
    headers: getHeaders()
  })
};
//vote
export const RatioConvert =(params) => {
  return fetch({
    url: `/pbcFlow/convert`,
    method: 'post',
    params,
    headers: getHeaders()
  });
};
export const DrawNumber = (params) => {
  return fetch({
    url: '/luckDraw/myNumbers',
    method: 'get',
    params,
    headers: getHeaders()
  })
};


export const PastMyApi =(params) => {
  return fetch({
    url: `/luckDraw/history`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

export const taskApi =(params) => {
  return fetch({
    url: `/task`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

export const taskSignApi =(params) => {
  return fetch({
    url: `/task/signin`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};

export const WebLogin = data => {
  return fetch({
    url: `/login`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

export const Register = data => {
  return fetch({
    url: `/register`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

export const retrievePassword = data => {
  return fetch({
    url: `/retrievePassword`,
    method: 'patch',
    data,
    headers: getHeaders()
  });
};

export const changePassword = data => {
  return fetch({
    url: `/user/updatePassword`,
    method: 'patch',
    data,
    headers: getHeaders()
  });
};
/**
 * 绑定手机号-发送验证码
 * bindMobile
 */
export const smsBind = data => {
  return fetch({
    url: '/sms',
    method: 'post',
    data,
    headers: getHeaders()
  });
};
/**
 * 绑定手机号-发送验证码
 * bindMobile
 */
export const smsBindMobile = data => {
  return fetch({
    url: '/sms/send',
    method: 'post',
    data,
    headers: getHeaders()
  });
};
/**
 * 领取奖品
 */
export const luckDrawReceiveApi = data => {
  return fetch({
    url: '/bidding/receipt',
    method: 'post',
    data,
    headers: getHeaders()
  })
};

export const taskSigninApi =data => {
  return fetch({
    url: `/task/signin`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};

export const taskCheckApi =data => {
  return fetch({
    url: `/task/check`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};


export const paymentMethodClear =data => {
  return fetch({
    url: `/user/paymentMethodClear`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};


export const bondTransfer =data => {
  return fetch({
    url: `/bond/transfer`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};


export const ticketTransfer =data => {
  return fetch({
    url: `/ticket/tran`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};



export const updateOrderSign =data => {
  return fetch({
    url: `/biddingOrder/updateOrderSign`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};
export const CollectApi = (params) => {
  return fetch({
    url: `/collect/store`,
    method: 'post',
    params,
    headers: getHeaders()
  });
};
/**
 * 商家首页
 */
export const storeIndexApi = (data) => {
  return fetch({
    url: '/store/index',
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

/**
 * 商家中心
 */
export const storeAchApi = (data) => {
  return fetch({
    url: '/store/ach',
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};
export const CollectIndexApi = data => {
  return fetch({
    url: `/store/lists`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

/**
 * 店铺申请-获取支付价格
 *
 */
export const applyMoneyApi = (params) => {
  return fetch({
    url: `/store/applyMoney`,
    method: 'get',
    params,
    headers: getHeaders()
  });
};
/**
 * 店铺申请-提交
 *
 */
export const storeApplyApi = data => {
  return fetch({
    url: `/store/apply`,
    method: 'post',
    data,
    headers: getHeaders()
  });
};
export const upgradePayApi = data => {
  return fetch({
    url: `/store/upgradePay`,
    method: 'post',
    params: data,
    headers: getHeaders()
  });
};



export const upgradeUpdateApi = data => {
  return fetch({
    url: `/store/upgradeUpdate`,
    method: 'post',
    params: data,
    headers: getHeaders()
  });
};


/** 
 * 卡项接口
*/
//我的卡项
export const myGoodsCardApi = data => {
  return fetch({
    url: `/myGoodsCard/list`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//卡项核销
export const useCardApi = data => {
  return fetch({
    url: `/goodsCard/useCard`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//卡项使用记录（用户）
export const goodsCardRecordApi = data => {
  return fetch({
    url: `/goodsCard/getGoodsCardRecord`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//卡项使用记录（店铺）
export const goodsCardRecordByStoreApi = data => {
  return fetch({
    url: `/goodsCard/getGoodsCardRecordByStore`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

/** 
 * 购物车接口
*/
//获取购物车
export const getShopCartApi = data => {
  return fetch({
    url: `/shopCart/list`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//设置购物车
export const setShopCartApi = data => {
  return fetch({
    url: `/shopCart/set`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//设置购物车
export const shopCartConfirmApi = data => {
  return fetch({
    url: `/shopCart/confirm`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//设置购物车
export const shopCartStoreApi = data => {
  return fetch({
    url: `/shopCart/store`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//查询购物车订单购物车
export const shopCartFindOrderApi = data => {
  return fetch({
    url: `/shopCart/otherFind`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//查询购物车订单购物车
export const shopCartPayApi = data => {
  return fetch({
    url: `/shopCart/otherPay`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};
//联盟商家分类
export const storeClassApi = data => {
  return fetch({
    url: `/store/class`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//联盟商家主页，banner，分类，商铺列表
export const storeHomeApi = data => {
  return fetch({
    url: `/store/home`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//联盟商家关注
export const storeFollowApi = data => {
  return fetch({
    url: `/store/follow`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//商户商品
export const storeGoodsApi = data => {
  return fetch({
    url: `/store/storeGoods`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//商户评论列表
export const storeCommentApi = data => {
  return fetch({
    url: `/store/commentList`,
    method: 'get',
    params: data,
    headers: getHeaders()
  });
};

//商户评价
export const storeCommentAddApi = data => {
  return fetch({
    url: `/store/comment`,
    method: 'post',
    params: data,
    headers: getHeaders()
  });
};

//我的关注
export const storeMyFollowApi = data => {
  return fetch({
    url: `/store/myFollow`,
    method: 'post',
    params: data,
    headers: getHeaders()
  });
};

//商户核销记录
export const storeCardRecordApi = data => {
  return fetch({
    url: `/goodsCard/cardRecord`,
    method: 'post',
    params: data,
    headers: getHeaders()
  });
};

//商户提货记录
export const storeCardApplyListApi = data => {
  return fetch({
    url: `/goodsCard/applyList`,
    method: 'post',
    params: data,
    headers: getHeaders()
  });
};

//商户提货申请
export const storeCardApplyApi = data => {
  return fetch({
    url: `/goodsCard/apply`,
    method: 'post',
    params: data,
    headers: getHeaders()
  });
};






// WEBPACK FOOTER //
// ./src/axios/api.js